import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  FormControl,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/system";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";

// dnd
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  DraggableProvided,
  DraggableStateSnapshot,
} from "react-beautiful-dnd";

// InterFace
import { LIST_POST } from "../config/const";
import { useWindowSize } from "../lib/useWindowSize";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

interface InputProductOptionProps {
  selectOption: any;
  setEelectOption: (select_option: any) => void;
  editProductOptionPlans: {
    service_plan_id: number;
    service_plan_name: string;
  }[];
  editProductOptionContents: {
    service_content_id: number;
    service_content_name: string;
  }[];
  editTossUpFormOptionProducts: {
    high_rank_company_name: string;
    product_id: number;
    product_name: string;
  }[];
  editOutsideServices: {
    outside_entry_form_service_id: number;
    outside_entry_form_service_name: string;
  }[];
  optionNameList: string[];
  editProduct: { [key: string]: any } | null;
}

function InputProductOption(props: InputProductOptionProps) {
  const {
    selectOption,
    setEelectOption,
    editProductOptionPlans,
    editProductOptionContents,
    editTossUpFormOptionProducts,
    editOutsideServices,
    optionNameList,
    editProduct,
  } = props;

  const pathname = useAtomValue(AppAtoms.pathname);
  const [selectNameList, setSelectNameList] = useState<string[]>([]);
  useEffect(() => {
    if (editProduct && editProduct.product_option) {
      if (selectOption.depend_option_name !== "他質問に依存しない") {
        editProduct.product_option.map((optionInf: any) => {
          if (optionInf.option_name === selectOption.depend_option_name) {
            setSelectNameList(optionInf.option_select);
          }
        });
      } else {
        setSelectNameList([]);
      }
    }
  }, [selectOption.depend_option_name]);
  return (
    <>
      <Box key={"addBoxOption2_"}>
        <SerchTextField
          width="calc(100% - 10px)"
          key={"serchColumnBubun"}
          label={"質問名"}
          helperText={""}
          value={selectOption["option_name"]}
          setValue={(value) => {
            setEelectOption({
              ...selectOption,
              option_name: value,
            });
          }}
          dataKey={""}
          addData={{}}
        />
      </Box>
      <Box key={"addBoxOption4_"}>
        <Box className="serch-label">質問区分</Box>
        <FormControl
          fullWidth
          sx={{
            marginTop: "10px",
            marginBottom: "20px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          <Select
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["option_type"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                option_type: Number(e.target.value),
                option_default_value: "",
                change_value_conf: 0,
                tel_flg: 0,
                name_flg: 0,
                company_name_flg: 0,
                zip_code_flg: 0,
                address_flg: 0,
                space_flg: 0,
                mail_address_flg: 0,
                form_tel_flg: 0,
                multi_text_flg: 0,
                contract_number_flg: 0,
                half_width_number_flg: 0,
                option_select: [""],
              });
            }}
            sx={{
              height: "30px",
              textAlign: "end",
              fontSize: "14px",
            }}
          >
            {LIST_POST["option_type"].map((input, i) => {
              return (
                <MenuItem
                  key={"input" + i}
                  value={input.id}
                  sx={{
                    fontSize: "14px",
                    height: input.value === "" ? "14px" : "24px",
                  }}
                >
                  {input.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      {selectOption["option_type"] === 0 ? (
        <Box key={"addBoxOption99_"}>
          <Box className="serch-label">フラグ設定</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={
                selectOption["tel_flg"] == 1
                  ? 1
                  : selectOption["name_flg"] == 1
                    ? 2
                    : selectOption["zip_code_flg"] == 1
                      ? 3
                      : selectOption["address_flg"] == 1
                        ? 4
                        : selectOption["space_flg"] == 1
                          ? 5
                          : selectOption["mail_address_flg"] == 1
                            ? 6
                            : selectOption["form_tel_flg"] == 1
                              ? 7
                              : selectOption["multi_text_flg"] == 1
                                ? 8
                                : selectOption["company_name_flg"] == 1
                                  ? 9
                                  : selectOption["contract_number_flg"] == 1
                                    ? 10
                                    : selectOption["half_width_number_flg"] == 1
                                      ? 11
                                      : 0
              }
              onChange={(e) => {
                if (Number(e.target.value) === 0) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 1) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 1,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 2) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 1,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 3) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 1,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 4) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 1,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 5) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 1,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 6) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 1,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 7) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 1,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 8) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 1,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 9) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    depend_product_ids: [],
                    depend_plan_ids: [],
                    depend_content_ids: [],
                    depend_outside_entry_form_service_ids: [],
                    depend_option_name: "他質問に依存しない",
                    depend_select_names: [],
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 1,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 10) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 1,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 11) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 1,
                  });
                }
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {pathname === "/entry_form"
                ? (
                    LIST_POST["entry_form_option_flg"] as {
                      id: number;
                      value: string;
                    }[]
                  )
                    .filter(
                      (input) =>
                        input.id !== 10 ||
                        (String(editProduct?.product_key) === "0" &&
                          String(editProduct?.product_contract_number) === "1"),
                    )
                    .map((input, i) => (
                      <MenuItem
                        key={"input" + i}
                        value={input.id}
                        sx={{
                          fontSize: "14px",
                          height: input.value === "" ? "14px" : "24px",
                        }}
                      >
                        {input.value}
                      </MenuItem>
                    ))
                : pathname === "/outside_entry_form"
                  ? LIST_POST["contract_option_flg"].map((input, i) => (
                      <MenuItem
                        key={"input" + i}
                        value={input.id}
                        sx={{
                          fontSize: "14px",
                          height: input.value === "" ? "14px" : "24px",
                        }}
                      >
                        {input.value}
                      </MenuItem>
                    ))
                  : pathname === "/toss_up_form"
                    ? LIST_POST["toss_up_option_flg"].map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input.id}
                            sx={{
                              fontSize: "14px",
                              height: input.value === "" ? "14px" : "24px",
                            }}
                          >
                            {input.value}
                          </MenuItem>
                        );
                      })
                    : null}
            </Select>
          </FormControl>
        </Box>
      ) : selectOption["option_type"] === 1 ||
        selectOption["option_type"] === 2 ? (
        <>
          {selectOption.option_select.map(
            (option_select: string, select_i: number) => {
              return (
                <Box
                  key={"addBoxOptionSelect_" + select_i}
                  sx={{ height: "87px" }}
                >
                  <SerchTextField
                    width="calc(100% - 80px)"
                    key={"serchColumnBubun" + select_i}
                    label={"選択肢 - " + (select_i + 1)}
                    helperText={""}
                    value={option_select}
                    setValue={(value) => {
                      let _option_select = selectOption.option_select.concat();
                      _option_select[select_i] = value;
                      setEelectOption({
                        ...selectOption,
                        option_select: _option_select,
                      });
                    }}
                    dataKey={""}
                    addData={{}}
                  />
                  {selectOption.option_select.length > 1 ? (
                    <Button
                      style={{
                        height: "32px",
                        width: "32px",
                        marginLeft: "calc(100% - 75px)",
                        marginTop: "-110px",
                      }}
                      onClick={(e) => {
                        let _option_select =
                          selectOption.option_select.concat();
                        _option_select = _option_select.filter(
                          (_product_option: string, _select_i: number) =>
                            select_i !== _select_i,
                        );
                        setEelectOption({
                          ...selectOption,
                          option_select: _option_select,
                        });
                      }}
                    >
                      <RemoveCircleOutlineIcon fontSize="medium" />
                    </Button>
                  ) : null}
                </Box>
              );
            },
          )}
          <Box key={"addBoxPriceDataDelete"} sx={{ height: "20px" }}>
            <Button
              style={{
                fontSize: "20px",
                marginTop: "-40px",
                marginLeft: "calc(100% - 140px)",
              }}
              onClick={() => {
                let _option_select = selectOption.option_select.concat();
                _option_select.push("");
                setEelectOption({
                  ...selectOption,
                  option_select: _option_select,
                });
              }}
            >
              <AddCircleOutlineIcon fontSize="medium" />
            </Button>
          </Box>
        </>
      ) : null}
      <Box key={"addBoxOption3_"}>
        <Box className="serch-label">必須フラグ</Box>
        <Checkbox
          disabled={
            editProduct?.product_key === "1" && selectOption["tel_flg"] === 1
          }
          checked={selectOption["required_optional"] === 1}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              required_optional:
                selectOption["required_optional"] === 1 ? 0 : 1,
            });
          }}
          sx={{
            "& .MuiSvgIcon-root": { fontSize: 18 },
            width: "36px",
          }}
        />
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 36px)",
            marginLeft: "36px",
            marginTop: "-26px",
            marginBottom: "18px",
          }}
        >
          ※必須項目とする場合はチェックしてください。
        </FormHelperText>
      </Box>
      {pathname === "/outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption4_outside_form"}>
          <Box className="serch-label">外部ETフォームでの表示</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption["outside_form_display"]}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  outside_form_display: Number(e.target.value),
                });
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {LIST_POST["outside_form_display"].map((input, i) => {
                return (
                  <MenuItem
                    key={"input" + i}
                    value={input.id}
                    sx={{
                      fontSize: "14px",
                      height: input.value === "" ? "14px" : "24px",
                    }}
                  >
                    {input.value}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              id="serch-name"
              sx={{
                textAlign: "right",
              }}
            >
              ※外部ETフォームに表示するかどうかを選択できます
            </FormHelperText>
          </FormControl>
        </Box>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <Box key={"addBoxOption_default"}>
          <SerchTextField
            width="calc(100% - 10px)"
            key={"serchColumnBubun"}
            label={"デフォルト値"}
            helperText={""}
            value={selectOption["option_default_value"]}
            setValue={(value) => {
              if (value === "") {
                setEelectOption({
                  ...selectOption,
                  option_default_value: value,
                  change_value_conf: 0,
                });
              } else {
                setEelectOption({
                  ...selectOption,
                  option_default_value: value,
                });
              }
            }}
            dataKey={""}
            addData={{}}
            multiline={selectOption.multi_text_flg === 1}
            rows={4}
          />
        </Box>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <Box key={"addBoxOption4_edit_input"}>
          <Box className="serch-label">入力値の編集</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              disabled={selectOption.option_default_value === ""}
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption["change_value_conf"]}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  change_value_conf: Number(e.target.value),
                });
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {LIST_POST["change_value_conf"].map((input, i) => {
                return (
                  <MenuItem
                    key={"input" + i}
                    value={input.id}
                    sx={{
                      fontSize: "14px",
                      height: input.value === "" ? "14px" : "24px",
                    }}
                  >
                    {input.value}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              id="serch-name"
              sx={{
                textAlign: "right",
              }}
            >
              ※デフォルト値が設定されているときのみ、入力値の編集を不可に変更できます。
            </FormHelperText>
          </FormControl>
        </Box>
      ) : null}
      <Box key={"addBoxOption5_"}>
        <SerchTextField
          width="calc(100% - 10px)"
          key={"serchColumnBubun"}
          label={"説明"}
          helperText={""}
          value={selectOption["option_comment"]}
          setValue={(value) => {
            setEelectOption({
              ...selectOption,
              option_comment: value,
            });
          }}
          dataKey={""}
          addData={{}}
        />
      </Box>
      <Box key={"addBoxOption4_sns"}>
        <Box className="serch-label">チャットアプリ連携</Box>
        <FormControl
          fullWidth
          sx={{
            marginTop: "10px",
            marginBottom: "20px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          <Select
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["sns_send"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                sns_send: Number(e.target.value),
              });
            }}
            sx={{
              height: "30px",
              textAlign: "end",
              fontSize: "14px",
            }}
          >
            {LIST_POST["sns_send"].map((input, i) => {
              return (
                <MenuItem
                  key={"input" + i}
                  value={input.id}
                  sx={{
                    fontSize: "14px",
                    height: input.value === "" ? "14px" : "24px",
                  }}
                >
                  {input.value}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
              height: "25px",
            }}
          >
            ※チャットアプリ連携した際にエントリー情報として連携するかどうか選択できます。
          </FormHelperText>
        </FormControl>
      </Box>
      {pathname === "/toss_up_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box className="serch-label">依存商材選択</Box>
          {editTossUpFormOptionProducts.map((product) => {
            return (
              <Box className="serch-label" sx={{ marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_product_ids.findIndex(
                      (planID: number) => planID === product.product_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_product_ids =
                      selectOption.depend_product_ids.concat();

                    if (
                      selectOption.depend_product_ids.findIndex(
                        (planID: number) => planID === product.product_id,
                      ) > -1
                    ) {
                      depend_product_ids = depend_product_ids.filter(
                        (planID: number) => planID !== product.product_id,
                      );
                    } else {
                      depend_product_ids.push(product.product_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_product_ids: depend_product_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {`${product.high_rank_company_name} / ${product.product_name}`}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
            }}
          >
            ※依存商材が選択されているかどうかで、質問の表示が制御されます。
          </FormHelperText>
        </Box>
      ) : null}
      {pathname === "/entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box className="serch-label">依存プラン選択</Box>
          {editProductOptionPlans.map((service) => {
            return (
              <Box className="serch-label" sx={{ marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_plan_ids.findIndex(
                      (planID: number) => planID === service.service_plan_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_plan_ids = selectOption.depend_plan_ids.concat();

                    if (
                      selectOption.depend_plan_ids.findIndex(
                        (planID: number) => planID === service.service_plan_id,
                      ) > -1
                    ) {
                      depend_plan_ids = depend_plan_ids.filter(
                        (planID: number) => planID !== service.service_plan_id,
                      );
                    } else {
                      depend_plan_ids.push(service.service_plan_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_plan_ids: depend_plan_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.service_plan_name}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
            }}
          >
            ※依存プランが選択されているかどうかで、質問の表示が制御されます。
          </FormHelperText>
        </Box>
      ) : null}
      {pathname === "/entry_form" &&
      editProductOptionContents.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_content"}>
          <Box className="serch-label">依存コンテンツ一覧</Box>
          {editProductOptionContents.map((service) => {
            return (
              <Box className="serch-label" sx={{ marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_content_ids.findIndex(
                      (contentID: number) =>
                        contentID === service.service_content_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_content_ids =
                      selectOption.depend_content_ids.concat();

                    if (
                      selectOption.depend_content_ids.findIndex(
                        (contentID: number) =>
                          contentID === service.service_content_id,
                      ) > -1
                    ) {
                      depend_content_ids = depend_content_ids.filter(
                        (contentID: number) =>
                          contentID !== service.service_content_id,
                      );
                    } else {
                      depend_content_ids.push(service.service_content_id);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_content_ids: depend_content_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.service_content_name}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
            }}
          >
            ※依存コンテンツが選択されているかどうかで、質問の表示が制御されます。
          </FormHelperText>
        </Box>
      ) : null}
      {pathname === "/outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 &&
      editOutsideServices.length > 0 ? (
        <Box key={"addBoxOption_depend_plan"}>
          <Box className="serch-label">依存外部サービス選択</Box>
          {editOutsideServices.map((service) => {
            return (
              <Box className="serch-label" sx={{ marginRight: "25px" }}>
                <Checkbox
                  checked={
                    selectOption.depend_outside_entry_form_service_ids.findIndex(
                      (planID: number) =>
                        planID === service.outside_entry_form_service_id,
                    ) > -1
                  }
                  onClick={() => {
                    let depend_outside_entry_form_service_ids =
                      selectOption.depend_outside_entry_form_service_ids.concat();

                    if (
                      selectOption.depend_outside_entry_form_service_ids.findIndex(
                        (planID: number) =>
                          planID === service.outside_entry_form_service_id,
                      ) > -1
                    ) {
                      depend_outside_entry_form_service_ids =
                        depend_outside_entry_form_service_ids.filter(
                          (planID: number) =>
                            planID !== service.outside_entry_form_service_id,
                        );
                    } else {
                      depend_outside_entry_form_service_ids.push(
                        service.outside_entry_form_service_id,
                      );
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_outside_entry_form_service_ids:
                        depend_outside_entry_form_service_ids,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {service.outside_entry_form_service_name}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
            }}
          >
            ※依存外部サービスが選択されているかどうかで、質問の表示が制御されます。
          </FormHelperText>
        </Box>
      ) : null}
      {optionNameList.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_option"}>
          <Box className="serch-label">依存質問名選択</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption.depend_option_name}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  depend_option_name: e.target.value,
                  depend_select_names: [],
                });
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {optionNameList.map((optionName, i) => {
                if (optionName != selectOption.option_name) {
                  return (
                    <MenuItem
                      key={"input" + i}
                      value={optionName}
                      sx={{
                        fontSize: "14px",
                        height: optionName === "" ? "14px" : "24px",
                      }}
                    >
                      {optionName}
                    </MenuItem>
                  );
                }
              })}
            </Select>
            <FormHelperText
              id="serch-name"
              sx={{
                textAlign: "right",
              }}
            >
              ※選択した質問の情報が変更されると、設定が「他質問に依存しない」にリセットされます。
            </FormHelperText>
          </FormControl>
        </Box>
      ) : null}

      {selectNameList.length > 0 &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption_depend_option_select"}>
          <Box className="serch-label">依存選択肢一覧</Box>
          {selectNameList.map((selectName) => {
            return (
              <Box className="serch-label" sx={{ marginRight: "25px" }}>
                <Checkbox
                  checked={selectOption.depend_select_names.includes(
                    selectName,
                  )}
                  onClick={() => {
                    let depend_select_names =
                      selectOption.depend_select_names.concat();

                    if (selectOption.depend_select_names.includes(selectName)) {
                      depend_select_names = depend_select_names.filter(
                        (_selectName: string) => _selectName !== selectName,
                      );
                    } else {
                      depend_select_names.push(selectName);
                    }
                    setEelectOption({
                      ...selectOption,
                      depend_select_names: depend_select_names,
                    });
                  }}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 16 },
                    marginTop: "-5px",
                  }}
                />
                {selectName}
              </Box>
            );
          })}
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
            }}
          >
            ※依存選択肢が選択されているかどうかで、質問の表示が制御されます。
          </FormHelperText>
        </Box>
      ) : null}
    </>
  );
}
const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};
function SerchTextField({
  width,
  label,
  helperText,
  value,
  setValue,
  dataKey,
  addData,
  multiline,
  rows,
}: {
  width: string;
  label: string;
  helperText: string;
  value: string;
  setValue: (value: string) => void;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
  multiline?: boolean;
  rows?: number;
}) {
  const textFieldMargin = "10px 5px ";
  return (
    <Box>
      <Box className="serch-label">{label}</Box>
      <CustomTextField
        disabled={
          dataKey === "sns_id" &&
          (Number(addData["sns_type"]) == 2 || Number(addData["sns_type"]) == 3)
            ? true
            : false
        }
        type={dataKey !== "password" ? "text" : "password"}
        id="textFieldId"
        value={value}
        size="small"
        multiline={multiline}
        rows={rows}
        onChange={(e) => setValue(e.target.value)}
        sx={{ width, margin: textFieldMargin, ...(multiline ? { "& .MuiInputBase-input": { height: "auto" } } : {}) }}
      />
      <FormHelperText
        id="serch-name"
        sx={{
          width,
          textAlign: "right",
          marginTop: "-8px",
          height: "25px",
        }}
      >
        {helperText}
      </FormHelperText>
    </Box>
  );
}

interface ProductEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editProduct: { [key: string]: any } | null;
  setEditProduct: (data: { [key: string]: any } | null) => void;
  putEditProduct: () => void;
  editProductOptionPlans: {
    service_plan_id: number;
    service_plan_name: string;
  }[];
  editProductOptionContents: {
    service_content_id: number;
    service_content_name: string;
  }[];
  editTossUpFormOptionProducts: {
    high_rank_company_name: string;
    product_id: number;
    product_name: string;
  }[];
  editOutsideServices: {
    outside_entry_form_service_id: number;
    outside_entry_form_service_name: string;
  }[];
}
export function ProductEditModal(props: ProductEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editProduct,
    setEditProduct,
    putEditProduct,
    editProductOptionPlans,
    editProductOptionContents,
    editTossUpFormOptionProducts,
    editOutsideServices,
  } = props;
  const pathname = useAtomValue(AppAtoms.pathname);
  const { windowWidth, windowHeight } = useWindowSize();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width:
      editProduct && editProduct.status === "before"
        ? windowWidth > 868
          ? "800px"
          : "calc(100% - 82px)"
        : windowWidth > 568
          ? "500px"
          : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // 依存質問 - 選択肢の一覧
  const [optionNameList, setOptionNameList] = useState<string[]>([]);
  useEffect(() => {
    let optionNameList: string[] = ["他質問に依存しない"];
    if (editProduct && editProduct.product_option) {
      editProduct.product_option.map((optionInf: any) => {
        if (optionInf.option_type === 1 || optionInf.option_type === 2) {
          optionNameList.push(optionInf.option_name);
        }
      });
    }
    setOptionNameList(optionNameList);
  }, [editProduct]);
  // ドラッグが完了した際に呼ばれるコールバック
  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;
    // ドロップ先がない(リスト外にドロップされた)場合は何もしない
    if (!destination || !editProduct) return;

    // 元の場所と同じ場合は並び替え不要
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    // 配列をコピーし、ドラッグされた要素を抜き出し、目的地へ挿入
    const newProductOptions = Array.from(editProduct.product_option);
    const [removed] = newProductOptions.splice(source.index, 1);
    newProductOptions.splice(destination.index, 0, removed);

    // 並び替えが完了した後、sort_id を並び順に合わせて更新する
    // (1スタートの場合は index+1、0スタートなら index を使ってください)
    newProductOptions.forEach((option: any, index: number) => {
      option.sort_id = index + 1;
    });
    // 更新した配列をStateに反映させる
    setEditProduct({
      ...editProduct,
      product_option: newProductOptions,
    });
  };

  return editProduct ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          {pathname === "/entry_form"
            ? "エントリーフォーム - 質問一覧編集"
            : pathname === "/toss_up_form"
              ? "トスアップフォーム - 質問一覧編集"
              : pathname === "/outside_entry_form"
                ? "外部ETフォーム - 質問一覧編集"
                : ""}
        </Box>
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            mb: 5,
            maxHeight:
              editProduct && editProduct.status === "before"
                ? windowWidth > 385
                  ? undefined
                  : "calc(70vh - 30px)"
                : undefined,
            overflowY:
              editProduct && editProduct.status === "before"
                ? windowWidth > 385
                  ? undefined
                  : "auto"
                : undefined,
          }}
        >
          {editProduct.status === "before" ? (
            <>
              <Paper elevation={0}>
                <Box
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  {editProduct.select_option_index == null ? (
                    <>
                      {pathname === "/entry_form" ||
                      pathname === "/outside_entry_form" ? (
                        <>
                          <Box key={"addBoxProductName"}>
                            <Box className="serch-label">商材名</Box>
                            <CustomTextField
                              disabled
                              id="textFieldId"
                              size="small"
                              value={editProduct.product_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                          <Box key={"addBoxEntrySaleCompanyName"}>
                            <Box className="serch-label">
                              エントリーパートナー
                            </Box>
                            <CustomTextField
                              disabled
                              id="textFieldId"
                              size="small"
                              value={editProduct.entry_sale_company_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                        </>
                      ) : pathname === "/toss_up_form" ? (
                        <>
                          <Box key={"addBoxCategoryName"}>
                            <Box className="serch-label">カテゴリ名</Box>
                            <CustomTextField
                              disabled
                              id="textFieldId"
                              size="small"
                              value={editProduct.category_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                          <Box key={"addBoxEntrySaleCompanyName"}>
                            <Box className="serch-label">
                              トスアップパートナー
                            </Box>
                            <CustomTextField
                              disabled
                              id="textFieldId"
                              size="small"
                              value={editProduct.toss_up_company_name}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px ",
                              }}
                            />
                          </Box>
                        </>
                      ) : null}
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                          {(provided) => (
                            <Box
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              sx={{ width: "100%" }}
                            >
                              <Box
                                className="serch-label"
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "10px",
                                }}
                              >
                                質問一覧
                              </Box>
                              {editProduct.product_option.map(
                                (option: any, index: number) => (
                                  <Draggable
                                    key={option.sort_id}
                                    draggableId={String(option.sort_id)}
                                    index={index}
                                  >
                                    {(
                                      provided: DraggableProvided,
                                      snapshot: DraggableStateSnapshot,
                                    ) => (
                                      <>
                                        <Box
                                          key={"option_name_" + index}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          sx={{
                                            marginTop: "5px",
                                            height: "50px",
                                            width: "calc(100% - 88px)",
                                            marginLeft: "5px",
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "0 10px",
                                            backgroundColor: snapshot.isDragging
                                              ? "#f0f8ff"
                                              : "#fff",
                                          }}
                                          onClick={() => {
                                            setEditProduct({
                                              ...editProduct,
                                              select_option_index: index,
                                              select_option: option,
                                            });
                                          }}
                                        >
                                          {option.option_name}
                                        </Box>
                                        {editProduct.product_option.length >
                                        1 ? (
                                          <Button
                                            style={{
                                              height: "32px",
                                              width: "32px",
                                              marginLeft: "calc(100% - 70px)",
                                              marginTop: "-75px",
                                            }}
                                            onClick={() => {
                                              let product_option =
                                                editProduct.product_option.concat();
                                              const edit_option_name =
                                                option.option_name;

                                              //質問の削除
                                              product_option =
                                                product_option.filter(
                                                  (
                                                    _product_option: any,
                                                    _option_i: number,
                                                  ) => index !== _option_i,
                                                );

                                              // 依存設定の削除
                                              product_option =
                                                product_option.map(
                                                  (product_option: any) => {
                                                    if (
                                                      edit_option_name ===
                                                      product_option.depend_option_name
                                                    ) {
                                                      product_option[
                                                        "depend_option_name"
                                                      ] = "他質問に依存しない";
                                                      product_option[
                                                        "depend_select_names"
                                                      ] = [];
                                                    }
                                                    return product_option;
                                                  },
                                                );

                                              const option_id =
                                                option.option_id;
                                              let delete_option =
                                                editProduct.delete_option.concat();
                                              if (option_id) {
                                                delete_option.push(option_id);
                                              }
                                              setEditProduct({
                                                ...editProduct,
                                                product_option,
                                                delete_option,
                                              });
                                            }}
                                          >
                                            <RemoveCircleOutlineIcon fontSize="medium" />
                                          </Button>
                                        ) : null}
                                      </>
                                    )}
                                  </Draggable>
                                ),
                              )}
                              {provided.placeholder}
                            </Box>
                          )}
                        </Droppable>
                      </DragDropContext>
                      <Box
                        style={{
                          marginTop: "10px",
                          height: "40px",
                          width: "calc(100% - 10px)",
                          marginLeft: "5px",
                        }}
                      >
                        <Button
                          variant="outlined"
                          style={{
                            height: "40px",
                            width: "100%",
                          }}
                          onClick={() => {
                            let product_option =
                              editProduct.product_option.concat();
                            let max_sort_id = 1;
                            product_option.map((option: any) => {
                              if (option.sort_id > max_sort_id) {
                                max_sort_id = option.sort_id;
                              }
                            });
                            product_option.push({
                              option_name: "",
                              sns_send: 1,
                              required_optional: 0,
                              option_type: 0,
                              option_default_value: "",
                              change_value_conf: 0,
                              option_comment: "",
                              tel_flg: 0,
                              name_flg: 0,
                              company_name_flg: 0,
                              zip_code_flg: 0,
                              address_flg: 0,
                              space_flg: 0,
                              mail_address_flg: 0,
                              form_tel_flg: 0,
                              multi_text_flg: 0,
                              half_width_number_flg: 0,
                              contract_number_flg: 0,
                              option_select: [""],
                              sort_id: max_sort_id + 1,
                              outside_form_display: 0,
                              depend_product_ids: [],
                              depend_plan_ids: [],
                              depend_content_ids: [],
                              depend_outside_entry_form_service_ids: [],
                              depend_option_name: "他質問に依存しない",
                              depend_select_names: [],
                            });
                            setEditProduct({
                              ...editProduct,
                              product_option,
                              select_option_index:
                                editProduct.product_option.length,
                              select_option: {
                                option_name: "",
                                sns_send: 1,
                                required_optional: 0,
                                option_type: 0,
                                option_default_value: "",
                                change_value_conf: 0,
                                option_comment: "",
                                tel_flg: 0,
                                name_flg: 0,
                                company_name_flg: 0,
                                zip_code_flg: 0,
                                address_flg: 0,
                                space_flg: 0,
                                mail_address_flg: 0,
                                form_tel_flg: 0,
                                multi_text_flg: 0,
                                half_width_number_flg: 0,
                                contract_number_flg: 0,
                                option_select: [""],
                                sort_id: max_sort_id + 1,
                                outside_form_display: 0,
                                depend_product_ids: [],
                                depend_plan_ids: [],
                                depend_content_ids: [],
                                depend_outside_entry_form_service_ids: [],
                                depend_option_name: "他質問に依存しない",
                                depend_select_names: [],
                              },
                              add_select_option_flg: true,
                            });
                          }}
                        >
                          <Box className="m-plus-rounded-1c-modal">
                            質問追加
                          </Box>
                          <AddCircleOutlineIcon
                            sx={{
                              marginLeft: "6px",
                            }}
                            fontSize="medium"
                          />
                        </Button>
                      </Box>
                    </>
                  ) : (
                    editProduct.product_option.map(
                      (option: any, option_i: number) => {
                        if (editProduct.select_option_index === option_i) {
                          return (
                            <InputProductOption
                              selectOption={editProduct.select_option}
                              setEelectOption={(select_option: any) => {
                                setEditProduct({
                                  ...editProduct,
                                  select_option: select_option,
                                });
                              }}
                              editProductOptionPlans={editProductOptionPlans}
                              editProductOptionContents={
                                editProductOptionContents
                              }
                              editTossUpFormOptionProducts={
                                editTossUpFormOptionProducts
                              }
                              editOutsideServices={editOutsideServices}
                              optionNameList={optionNameList}
                              editProduct={editProduct}
                            />
                          );
                        }
                      },
                    )
                  )}
                </Box>
              </Paper>
              {editProduct.select_option_index == null ? (
                <Box
                  style={{ display: windowWidth > 385 ? "flex" : undefined }}
                >
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? undefined : "5px",
                    }}
                  >
                    <Button
                      disabled={editProduct.product_option.length === 0}
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      variant="contained"
                      onClick={() => {
                        const invalidOption = (editProduct.product_option as any[]).find(
                          (opt: any) => typeof opt.option_default_value === "string" && opt.option_default_value.includes("\n") && opt.multi_text_flg !== 1
                        );
                        if (invalidOption) {
                          setEditProduct({
                            ...editProduct,
                            status: `質問名「${invalidOption.option_name}」：「デフォルト値」に改行が含まれています。改行は「複数行フラグ」設定時のみ使用できます。`,
                          });
                          return;
                        }
                        putEditProduct();
                      }}
                    >
                      <Box className="m-plus-rounded-1c-regular">編集</Box>
                      <EditNoteIcon
                        sx={{ marginLeft: "6px", color: "white" }}
                        fontSize="medium"
                      />
                    </Button>
                  </Box>
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? "10px" : "5px",
                    }}
                  >
                    <Button
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      variant="contained"
                      onClick={swCloseModal}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        キャンセル
                      </Box>
                    </Button>
                  </Box>
                </Box>
              ) : (
                <Box
                  style={{ display: windowWidth > 385 ? "flex" : undefined }}
                >
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? undefined : "5px",
                    }}
                  >
                    <Button
                      disabled={editProduct.select_option.option_name === ""}
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      variant="contained"
                      onClick={() => {
                        let product_option =
                          editProduct.product_option.concat();
                        const edit_option_name =
                          product_option[editProduct.select_option_index]
                            .option_name;
                        product_option[editProduct.select_option_index] =
                          editProduct.select_option;
                        product_option = product_option.map(
                          (product_option: any) => {
                            if (
                              edit_option_name ===
                              product_option.depend_option_name
                            ) {
                              product_option["depend_option_name"] =
                                "他質問に依存しない";
                              product_option["depend_select_names"] = [];
                            }
                            return product_option;
                          },
                        );
                        setEditProduct({
                          ...editProduct,
                          select_option_index: null,
                          select_option: null,
                          add_select_option_flg: false,
                          product_option,
                        });
                      }}
                    >
                      <Box className="m-plus-rounded-1c-regular">OK</Box>
                    </Button>
                  </Box>
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? "10px" : "5px",
                    }}
                  >
                    <Button
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      variant="contained"
                      onClick={() => {
                        let product_option =
                          editProduct.product_option.concat();
                        if (editProduct.add_select_option_flg) {
                          product_option = product_option.filter(
                            (_product_option: any, _option_i: number) =>
                              editProduct.select_option_index !== _option_i,
                          );
                        }
                        setEditProduct({
                          ...editProduct,
                          select_option_index: null,
                          select_option: null,
                          add_select_option_flg: false,
                          product_option,
                        });
                      }}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        キャンセル
                      </Box>
                    </Button>
                  </Box>
                </Box>
              )}
            </>
          ) : editProduct.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">
                値の編集に成功しました。
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : editProduct.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                データの登録に失敗しました。
                <br />
                データの形式が異なる可能性があります。
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() => {
                    setEditProduct({
                      ...editProduct,
                      status: "before",
                    });
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">OK</Box>
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box className="shippori-antique-regular">
                {editProduct.status}
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() => {
                    if (editProduct.status && editProduct.status.startsWith("編集に成功しました。")) {
                      swCloseModal();
                    } else {
                      setEditProduct({
                        ...editProduct,
                        status: "before",
                      });
                    }
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">OK</Box>
                </Button>
              </Box>
            </>
          )}
        </Typography>
      </Box>
    </Modal>
  ) : null;
}
